import { useContext } from 'react';

import { PermissionsContext } from './permissions.context';
import { PermissionCheckerClient } from './permission-checker-client.interface';

export const usePermissions = (): PermissionCheckerClient => {
  return useContext(PermissionsContext);
};
